/* istanbul ignore next */
import { parse as parseQueryString } from 'querystring';
import cookie from 'cookie';

const COOKIE_NAME = 'isWebview';

const expireIsWebviewCookie = () => {
  document.cookie = `${COOKIE_NAME}=0;path=/; expires=${new Date()}`;
};

const isMobile = () =>
  (__CLIENT__ && !window.matchMedia('(min-width: 48em)').matches) || (__TEST__ && window.forceMobileForTesting);

const isMobileDevice = (userAgent = (__CLIENT__ || __TEST__) && navigator.userAgent) =>
  (__CLIENT__ || __TEST__) && /iPad|iPhone|iPod|Android|BlackBerry/.test(userAgent) && !window.MSStream;
const isIOSDevice = (userAgent = (__CLIENT__ || __TEST__) && navigator.userAgent) =>
  (__CLIENT__ || __TEST__) && /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

const isWebview = queryString => {
  let webview = false;
  if (__CLIENT__ || __TEST__) {
    const hasWebviewCookie = cookie.parse(document.cookie)[COOKIE_NAME] === '1';
    const queryParams = parseQueryString((queryString || '').replace(/^\?/, ''));
    const hasWebviewQueryParam = queryParams.webview === '1';
    const onMobileDevice = __TEST__ ? true : isMobileDevice();
    webview = (hasWebviewCookie || hasWebviewQueryParam) && onMobileDevice;
    const cookieValue = webview ? 1 : 0;
    document.cookie = `${COOKIE_NAME}=${cookieValue};path=/;`;
  }
  return webview;
};

export { expireIsWebviewCookie, isIOSDevice, isWebview, isMobileDevice, COOKIE_NAME };
export default isMobile;
